import {
  index,
  integer,
  pgTable,
  unique,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';
import { price_zone } from './sku-v2';

export const municipality = pgTable(
  'municipality',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    name: varchar('name', { length: 255 }).notNull(),
    priority: integer('priority').default(0).notNull(),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
  },
  (table) => {
    return {
      createdAtTs_idx: index('municipality_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      tenantId_idx: index('municipality_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('municipality_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('municipality_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('municipality_versionNumber_idx').on(
        table.versionNumber,
      ),
    };
  },
);

export const municipality_history = pgTable('municipality_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  name: varchar('name', { length: 255 }),
  priority: integer('priority'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
});

export const municipality_price_zone = pgTable(
  'municipality_price_zone',
  {
    ...defaultFields.fieldsWithTenantId(),
    municipalityId: uuid('municipalityId')
      .notNull()
      .references(() => municipality.id, { onDelete: 'cascade' }),
    priceZoneId: uuid('priceZoneId')
      .notNull()
      .references(() => price_zone.id, { onDelete: 'cascade' }),
  },
  (table) => ({
    assignmentUnique: unique('municipality_price_zone_assignment_unique').on(
      table.municipalityId,
      table.priceZoneId,
    ),
    tenantIdIdx: index('municipality_price_zone_tenant_id_idx').on(
      table.tenantId,
    ),
    municipalityIdIdx: index('municipality_price_zone_municipality_id_idx').on(
      table.municipalityId,
    ),
    priceZoneIdIdx: index('municipality_price_zone_price_zone_id_idx').on(
      table.priceZoneId,
    ),
  }),
);
